import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Modal,
  Form,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  FormFeedback,
  InputGroup,
  FormControl,
  InputGroupText,
  FormGroup,
  Table,
  Button,
} from "reactstrap";
import { Link, useSearchParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";

import TableContainer from "../../Components/Common/TableContainer";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../Components/Common/Loader";

import { useReactTable } from "@tanstack/react-table";
import axios from "axios";
import { fetchProducts } from "../../lib/Apis";

const Products = () => {
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("id");
  const [isEdit, setIsEdit] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [isTranslation, setIsTranslation] = useState(false);
  const [translations, setTranslations] = useState([]);
  const [prodName, setProdName] = useState("");
  const [prodNameError, setProdNameError] = useState(false);
  const [prodDesc, setProdDesc] = useState("");
  const [prodDescError, setProdDescError] = useState(false);
  const [selectedLocale, setSelectedLocale] = useState("");
  const [locale, setLocale] = useState([]);
  const [translationLocaleError, setTranslationLocaleError] = useState(false);
  const [selectedTranId, setSelectedTranId] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const limit = 10;

  // Delete customer
  const fileInputRef = useRef(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [modal, setModal] = useState(false);
  const [addModal, setAddModal] = useState(false);

  const toggle = useCallback(
    (arg) => {
      if (modal || addModal) {
        setModal(false);
        setSelectedProduct(null);
        setSelectedId("");
        setAddModal(false);
        setTranslations([]);
        setIsTranslation(false);
      } else if (arg === "add") {
        setAddModal(true);
      } else {
        setModal(true);
      }
    },
    [modal, addModal]
  );

  const {
    data: products = [],
    isLoading: productsLoading = false,
    isError,
    error: productsError = false,
  } = useQuery({
    queryKey: ["products", categoryId, page, limit, searchTerm],
    queryFn: () => fetchProducts(categoryId, page, limit, searchTerm),
  });

  const productsData = products?.data ?? [];
  const totalPages = products?.totalPages;

  //   const {
  //     data: singleBrand = [],
  //     isLoading: singleBrandLoading = false,
  //     error: singleBrandError = false,
  //   } = useQuery({
  //     queryKey: ["singleBrand", selectedId],
  //     queryFn: () => fetchSingleBrand(selectedId),
  //     enabled: !!selectedId,
  //   });

  //   const singleBrandData = singleBrand?.data ?? [];

  //   useEffect(() => {
  //     if (singleBrand?.data) {
  //       setTranslations(singleBrand?.data?.translations ?? []);
  //     }
  //   }, [singleBrand?.data?.id]);

  //   const {
  //     data: translation = [],
  //     isLoading: translationsLoading = false,
  //     isError: isTranslationError = false,
  //     error: translationsError = false,
  //   } = useQuery({
  //     queryKey: ["translations"],
  //     queryFn: () => fetchTranslations(),
  //   });

  //   let translationsData = translation?.data ?? [];
  const translationsData = [
    {
      locale: "en",
      name: "Beverages",
    },
    {
      locale: "fr",
      name: "Boissons",
    },
    {
      locale: "es",
      name: "Bebidas",
    },
    {
      locale: "de",
      name: "Getränke",
    },
  ];

  const updateProductMutation = useMutation({
    mutationFn: async (credentials) => {
      const token = sessionStorage.getItem("token");

      const { data } = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/product/${selectedId}/update`,
        credentials,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      toast.success("Product Updated !");
      toggle();
      validation.resetForm();
      queryClient.invalidateQueries(["products"]);
      validation.setSubmitting(false);
    },
    onError: (error) => {
      toast.error("Product updating failed !");
      validation.setSubmitting(false);
    },
  });

  const addProductMutation = useMutation({
    mutationFn: async (credentials) => {
      const token = sessionStorage.getItem("token");

      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/product/create`,
        credentials,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      toast.success("Added new Product");
      toggle();
      validation.resetForm();
      queryClient.invalidateQueries(["products"]);
      validation.setSubmitting(false);
    },
    onError: (error) => {
      toast.error("Product adding failed !");
      validation.setSubmitting(false);
    },
  });

  const ProductStatusMutation = useMutation({
    mutationFn: async (credentials) => {
      const token = sessionStorage.getItem("token");

      const { data } = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/product/${credentials.id}/status`,
        credentials,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["products"]);
    },
    onError: (error) => {
      toast.error("Product status updating failed !");
    },
  });



  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      product_name: selectedProduct?.product_name || "",
      product_image: selectedProduct?.product_image || null,
      price: selectedProduct?.price || null,
      description: selectedProduct?.description || null,
      ingredients: selectedProduct?.ingredients || null,
      isNewProduct: selectedProduct?.isNewProduct || 0,
    },

    validationSchema: Yup.object({
      product_name: Yup.string().required("Please Enter Product Name"),
      price: Yup.string().required("Please Enter Product Price"),
      description: Yup.string().required("Please Enter Product Description"),
      // ingredients: Yup.string().required("Please Enter Product Ingredients"),

      product_image: Yup.mixed()
  .test("imageTest", "Validation error", async function (value) {
    const createError = (msg) => this.createError({ message: msg });

    // ❌ No image at all — fail
    if (!value) return createError("Image is required");

    // ✅ If it's an existing image URL (edit mode), skip further validation
    if (typeof value === "string") return true;

    // ✅ If user uploads a file, validate it
    if (value instanceof File) {
      if (!["image/jpeg", "image/png", "image/jpg"].includes(value.type))
        return createError("Only .jpg, .jpeg, .png files are allowed");

      if (value.size > 2 * 1024 * 1024)
        return createError("File size is too large (max 2MB)");

      // ✅ Check image dimensions
      const checkImageDimensions = (file) =>
        new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            if (img.width !== 424 || img.height !== 320) {
              resolve(
                createError("Image dimensions must be exactly 424x320 pixels")
              );
            } else resolve(true);
          };
          img.onerror = () => resolve(createError("Invalid image file"));
          img.src = URL.createObjectURL(file);
        });

      return await checkImageDimensions(value);
    }

    return createError("Invalid image input");
  }),

    }),

    onSubmit: (values) => {

      const formData = new FormData();

      // Append common fields
      formData.append("name", values.product_name);
      formData.append("price", values.price);
      formData.append("description", values.description);
      formData.append("ingredients", values.ingredients);
      formData.append("isNewProduct", values.isNewProduct);
      formData.append("category", categoryId);

      // Append file only if it's a File object (new upload)
      formData.append("image", values.product_image);

      if (translations.length > 0) {
        formData.append("translations", JSON.stringify(translations));
      }

      if (isEdit) {
        formData.append("id", selectedProduct ? selectedProduct.id : 0);
        updateProductMutation.mutate(formData);
      } else {
        addProductMutation.mutate(formData);
      }
      
    },
  });

   const onClickDelete = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };

  const deleteProductMutation = useMutation({
      mutationFn: async (credentials) => {
        const token = sessionStorage.getItem("token");
  
        const { data } = await axios.patch(
          `${process.env.REACT_APP_API_BASE_URL}/product/${selectedId}/delete`,
          credentials,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        return data;
      },
      onSuccess: (data) => {
        queryClient.invalidateQueries(["products"]);
        setDeleteModal(false);
      },
      onError: (error) => {
        toast.error("Product deletion failed !");
      },
    });

  const newId = () => {
    return Math.floor(Math.random() * 1000000) + Date.now();
  };

  const saveTranslation = () => {
    let hasError = false;

    if (prodName === "") {
      setProdNameError(true);
      hasError = true;
    } else {
      setProdNameError(false);
    }
    if (prodDesc === "") {
      setProdDescError(true);
      hasError = true;
    } else {
      setProdDescError(false);
    }

    if (selectedLocale === "") {
      setTranslationLocaleError(true);
      hasError = true;
    } else {
      setTranslationLocaleError(false);
    }

    if (hasError) return;

    // Add or update translation
    setTranslations((prev) => {
      if (selectedTranId) {
        // Edit existing
        return prev.map((t) =>
          t.id === selectedTranId
            ? {
                ...t,
                locale: selectedLocale,
                product_name: prodName,
                description: prodDesc,
              }
            : t
        );
      } else {
        // Add new
        const id = newId();
        return [
          ...prev,
          {
            id,
            locale: selectedLocale,
            product_name: prodName,
            description: prodDesc,
          },
        ];
      }
    });

    // Clear inputs after successful save
    setProdName("");
    setProdDesc("");
    setSelectedLocale("");
    setSelectedTranId(null);
  };

  const handleToggle = async (id, status) => {
    const newStatus = status === 0 ? 1 : 0;

    ProductStatusMutation.mutate({ id, status: newStatus });
  };

  // Update Data
  const handleProductClick = useCallback(
    (arg) => {
      const product = arg;
      setSelectedId(product?._id);

      setSelectedProduct({
        id: product._id,
        product_image: product.image,
        product_name: product.name,
        price: product.price,
        description: product.description,
        ingredients: product.ingredients,
        isNewProduct: product.isNewProduct,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const onDelete = (id) => {
    setTranslations((prev) => prev.filter((t) => t.id !== id));
  };

  // Add Data
  const handleCustomerClicks = () => {
    setSelectedProduct("");
    setIsEdit(false);
    toggle();
  };

  useEffect(() => {
    const filteredTranslations = translationsData.filter(
      (item) => !translations.some((t) => t.locale === item.name)
    );

    setLocale(filteredTranslations);
  }, [isTranslation, translations]);

 

  // Customers Column
  const columns = useMemo(
    () => [
      {
        header: "Product Name",
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        header: "Description",
        accessorKey: "description",
        enableColumnFilter: false,
      },
      {
        header: "Ingredients",
        accessorKey: "ingredients",
        enableColumnFilter: false,
      },
      {
        header: "Price",
        accessorKey: "price",
        enableColumnFilter: false,
      },
      {
        header: "Image",
        accessorKey: "image",
        enableColumnFilter: false,
        cell: ({ row }) => {
          const imageUrl = `${process.env.REACT_APP_CLOUD_FRONT_URL}/${row.original.image}`;
          return (
            <div className="d-flex align-items-center gap-2">
              <img
                src={imageUrl}
                alt="Product"
                className="rounded-circle"
                style={{ width: "80px", height: "80px", objectFit: "cover" }}
              />
            </div>
          );
        },
      },

      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        cell: (cell) => {
          const value = cell.getValue(); // this will be 0 or 1
          if (value === 0) {
            return (
              <span className="badge text-uppercase bg-success-subtle text-success">
                Active
              </span>
            );
          } else if (value === 1) {
            return (
              <span className="badge text-uppercase bg-danger-subtle text-danger">
                Inactive
              </span>
            );
          } else {
            return (
              <span className="badge text-uppercase bg-info-subtle text-info">
                Unknown
              </span>
            );
          }
        },
      },
      {
        header: "Action",
        cell: (cellProps) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item edit" title="Edit">
                <button
                  type="button"
                  className="text-primary d-inline-block edit-item-btn border-0 bg-transparent p-0"
                  onClick={() => {
                    const brandsData = cellProps.row.original;
                    handleProductClick(brandsData);
                  }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </button>
              </li>
              <li className="list-inline-item toggle" title="Toggle Status">
                <FormGroup switch>
                  <Input
                    type="switch"
                    checked={cellProps.row.original.status === 0}
                    onChange={() =>
                      handleToggle(
                        cellProps.row.original._id,
                        cellProps.row.original.status
                      )
                    }
                  />
                </FormGroup>
              </li>
              <li className="list-inline-item" title="Remove">
                <button
                  className="text-danger d-inline-block border-0 bg-transparent p-0 remove-item-btn"
                  onClick={() => {
                    const dataId = cellProps.row.original._id;
                    onClickDelete(dataId);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </button>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleProductClick]
  );

  const cloudFrontUrl = process.env.REACT_APP_CLOUD_FRONT_URL;

  document.title = "Products | Brew Chew Menu Admin Panel";
  return (
    <React.Fragment>
      <div className="page-content">
        {/* <ExportCSVModal
          show={isExportCSV}
          onCloseClick={() => setIsExportCSV(false)}
          data={brandsData}
        /> */}

        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => deleteProductMutation.mutate({ isDeleted: 1 })}
          onCloseClick={() => setDeleteModal(false)}
        />

        <Container fluid>
          <BreadCrumb title="Products List" pageTitle="Products" />
          <Row>
            <Col lg={12}>
              <Card id="customerList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">Products List</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-success add-btn"
                          id="create-btn"
                          onClick={() => {
                            setIsEdit(false);
                            toggle("add");
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add
                          Product
                        </button>

                        <Link
                          to={`/product-sort?id=${categoryId}`}
                          type="button"
                          className="btn btn-primary add-btn"
                          id="create-btn"
                        >
                          <i className="ri-sort-asc align-bottom me-1"></i> Sort
                          Product
                        </Link>
                      </div>
                    </div>
                  </Row>
                  <Col sm={5}>
                    <InputGroup>
                      <InputGroupText>
                        <i className="bx bx-search-alt"></i>
                      </InputGroupText>
                      <Input
                        type="text"
                        placeholder="Search for products name..."
                        value={searchTerm ?? ""}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                </CardHeader>

                <div className="card-body pt-0">
                  <div>
                    {productsLoading ? (
                      <Loader error={productsError} />
                    ) : productsData.length === 0 ? (
                      <div className="text-center py-4 text-muted">
                        No Datas found.
                      </div>
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={productsData}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={10}
                        className="custom-header-css"
                        theadClass="table-light text-muted"
                      />
                    )}
                    <Row className="align-items-center mt-2 g-3 text-center text-sm-start">
                      <div className="col-sm"></div>
                      <div className="col-sm-auto">
                        <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
                          <li
                            className={`page-item ${
                              page <= 1 ? "disabled" : ""
                            }`}
                          >
                            <Button
                              
                              className="page-link"
                              onClick={() => {
                                if (page > 1) setPage(page - 1);
                              }}
                            >
                              Previous
                            </Button>
                          </li>

                          <li className="page-item">
                            <Link to="#" className="page-link active">
                              {page}
                            </Link>
                          </li>

                          <li
                            className={`page-item ${
                              page >= totalPages ? "disabled" : ""
                            }`}
                          >
                            <Button
                              
                              className="page-link"
                              onClick={() => {
                                if (page < totalPages) setPage(page + 1);
                              }}
                            >
                              Next
                            </Button>
                          </li>
                        </ul>
                      </div>
                    </Row>
                  </div>

                  <Modal
                    id="showModal"
                    isOpen={modal || addModal}
                    toggle={toggle}
                    centered
                  >
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {modal ? "Edit Product Details" : "Add Product Details"}
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <input type="hidden" id="id-field" />

                        <div
                          className="mb-3"
                          id="modal-id"
                          style={{ display: "none" }}
                        >
                          <Label htmlFor="id-field1" className="form-label">
                            ID
                          </Label>
                          <Input
                            type="text"
                            id="id-field1"
                            className="form-control"
                            placeholder="ID"
                            readOnly
                          />
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="product_name" className="form-label">
                            Product Name
                          </Label>
                          <Input
                            name="product_name"
                            id="product_name"
                            className="form-control"
                            placeholder="Enter Name"
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.product_name || ""}
                            invalid={
                              validation.touched.product_name &&
                              validation.errors.product_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.product_name &&
                          validation.errors.product_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.product_name}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="price" className="form-label">
                            Product Price
                          </Label>
                          <Input
                            name="price"
                            id="price"
                            className="form-control"
                            placeholder="Enter Price"
                            type="number"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.price || ""}
                            invalid={
                              validation.touched.price &&
                              validation.errors.price
                                ? true
                                : false
                            }
                          />
                          {validation.touched.price &&
                          validation.errors.price ? (
                            <FormFeedback type="invalid">
                              {validation.errors.price}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="description" className="form-label">
                            Product Description
                           
                          </Label>
                          <Input
                            name="description"
                            id="description"
                            className="form-control"
                            placeholder="Enter Description"
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description}
                            invalid={
                              validation.touched.description &&
                              validation.errors.description
                                ? true
                                : false
                            }
                          />
                          {validation.touched.description &&
                          validation.errors.description ? (
                            <FormFeedback type="invalid">
                              {validation.errors.description}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label d-block">
                            New Product
                          </Label>
                          <div className="d-flex gap-3">
                            <FormGroup check>
                              <Input
                                type="radio"
                                name="isNewProduct"
                                id="isNewProductYes"
                                value={1}
                                checked={validation.values.isNewProduct === 1}
                                onChange={(e) =>
                                  validation.setFieldValue(
                                    "isNewProduct",
                                    Number(e.target.value)
                                  )
                                }
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.isNewProduct &&
                                  validation.errors.isNewProduct
                                    ? true
                                    : false
                                }
                              />
                              <Label check htmlFor="isNewProductYes">
                                Yes
                              </Label>
                            </FormGroup>

                            <FormGroup check>
                              <Input
                                type="radio"
                                name="isNewProduct"
                                id="isNewProductNo"
                                value={0}
                                checked={validation.values.isNewProduct === 0}
                                onChange={(e) =>
                                  validation.setFieldValue(
                                    "isNewProduct",
                                    Number(e.target.value)
                                  )
                                }
                                onBlur={validation.handleBlur}
                              />
                              <Label check htmlFor="isNewProductNo">
                                No
                              </Label>
                            </FormGroup>
                          </div>

                          {validation.touched.isNewProduct &&
                          validation.errors.isNewProduct ? (
                            <FormFeedback type="invalid" className="d-block">
                              {validation.errors.isNewProduct}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="ingredients" className="form-label">
Product Ingredients ( separate each ingredient with a comma )
                          </Label>
                          <Input
                            name="ingredients"
                            id="ingredients"
                            className="form-control"
                            placeholder="Enter Ingredients"
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.ingredients}
                            invalid={
                              validation.touched.ingredients &&
                              validation.errors.ingredients
                                ? true
                                : false
                            }
                          />
                          {validation.touched.ingredients &&
                          validation.errors.ingredients ? (
                            <FormFeedback type="invalid">
                              {validation.errors.ingredients}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <Row className="mb-3">
                          <Col lg={3}>
                            <Label className="form-label">Image</Label>
                          </Col>

                          <Col lg={9}>
                            <div
                              style={{
                                display: "flex",
                                gap: "16px",
                                alignItems: "flex-start",
                              }}
                            >
                              {/* Upload section */}
                              <div
                                style={{
                                  flex: validation.values.product_image
                                    ? "1 1 70%"
                                    : "1 1 100%",
                                  border: "2px dashed #ccc",
                                  padding: "20px",
                                  textAlign: "center",
                                  borderRadius: "6px",
                                  cursor: "pointer",
                                  background: "#f8f8f8",
                                }}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={(e) => {
                                  e.preventDefault();
                                  if (
                                    e.dataTransfer.files &&
                                    e.dataTransfer.files[0]
                                  ) {
                                    validation.setFieldValue(
                                      "product_image",
                                      e.dataTransfer.files[0]
                                    );
                                  }
                                }}
                                onClick={() => fileInputRef.current.click()}
                              >
                                <input
                                  type="file"
                                  accept="image/*"
                                  ref={fileInputRef}
                                  onChange={(e) => {
                                    if (
                                      e.currentTarget.files &&
                                      e.currentTarget.files[0]
                                    ) {
                                      validation.setFieldValue(
                                        "product_image",
                                        e.currentTarget.files[0]
                                      );
                                    }
                                  }}
                                  style={{ display: "none" }}
                                />
                                <p className="mb-0">
                                  Drag & Drop your files or{" "}
                                  <span className="text-primary">Browse</span>
                                </p>
                                {validation.touched.product_image &&
                                  validation.errors.product_image && (
                                    <div className="text-danger mt-1">
                                      {validation.errors.product_image}
                                    </div>
                                  )}
                              </div>

                              {/* Preview section */}
                              {validation.values.product_image && (
                                <div
                                  style={{
                                    position: "relative",
                                    flex: "0 0 100px",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                  }}
                                >
                                  <img
                                    src={
                                      validation.values.product_image instanceof
                                      File
                                        ? URL.createObjectURL(
                                            validation.values.product_image
                                          ) // For uploaded files
                                        : validation.values.product_image
                                        ? `${cloudFrontUrl}/${validation.values.product_image}` // For existing image URL
                                        : "" // fallback if no image
                                    }
                                    alt="Preview"
                                    style={{
                                      width: "100%",
                                      height: "100px",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                  <button
                                    type="button"
                                    onClick={() => {
                                      validation.setFieldValue(
                                        "product_image",
                                        null
                                      ); // clear Formik value
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: "-8px",
                                      right: "-8px",
                                      background: "red",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "50%",
                                      width: "20px",
                                      height: "20px",
                                      cursor: "pointer",
                                      fontSize: "14px",
                                      lineHeight: "20px",
                                      textAlign: "center",
                                      padding: 0,
                                    }}
                                  >
                                    ×
                                  </button>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>

                        {/* <div className="d-flex justify-content-between align-items-center my-3">
                          <button
                            type="button"
                            className="btn btn-primary me-2"
                            onClick={() => setIsTranslation(true)}
                          >
                            Translations
                          </button>

                          {isTranslation && (
                            <button
                              type="button"
                              className="btn-close"
                              aria-label="Close"
                              onClick={() => setIsTranslation(false)}
                            />
                          )}
                        </div> */}

                        {isTranslation && (
                          <>
                            {/* Translations Table */}
                            {translations.length > 0 && (
                              <Table
                                bordered
                                hover
                                responsive
                                className="align-middle"
                              >
                                <thead className="table-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Locale</th>
                                    <th>Sub Category Name</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {translations.map((item, index) => (
                                    <tr key={item.id}>
                                      <td>{index + 1}</td>
                                      <td>{item.locale}</td>
                                      <td>{item.product_name}</td>
                                      <td>{item.description}</td>

                                      <td>
                                        <ul className="list-inline hstack gap-2 mb-0">
                                          {/* Edit */}
                                          <li
                                            className="list-inline-item edit"
                                            title="Edit"
                                          >
                                            <Link
                                              to="#"
                                              className="text-primary d-inline-block"
                                              onClick={() => {
                                                setProdDesc(item.description);
                                                setProdName(item.product_name);
                                                setSelectedLocale(item.locale);
                                                setSelectedTranId(item.id);
                                              }}
                                            >
                                              <i className="ri-pencil-fill fs-16"></i>
                                            </Link>
                                          </li>
                                          {/* Delete */}
                                          <li
                                            className="list-inline-item"
                                            title="Delete"
                                          >
                                            <Link
                                              to="#"
                                              className="text-danger d-inline-block"
                                              onClick={() => onDelete(item.id)}
                                            >
                                              <i className="ri-delete-bin-fill fs-16"></i>
                                            </Link>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            )}

                            <FormGroup className="mt-3">
                              <Label for="locale" className="fw-semibold">
                                Locale
                              </Label>
                              <Input
                                id="locale"
                                type="select"
                                value={selectedLocale}
                                onChange={(e) =>
                                  setSelectedLocale(e.target.value)
                                }
                              >
                                <option value="">-- Select Locale --</option>
                                {locale.map((l) => (
                                  <option key={l.id} value={l.name}>
                                    {l.name}
                                  </option>
                                ))}
                              </Input>
                              {translationLocaleError && (
                                <div className="text-danger mt-1">
                                  Locale is required
                                </div>
                              )}
                            </FormGroup>

                            <FormGroup className="mt-3">
                              <Label className="fw-semibold">
                                {" "}
                                Product Name
                              </Label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder=" Product Name"
                                value={prodName}
                                onChange={(e) => setProdName(e.target.value)}
                              />
                              {prodNameError && (
                                <div className="text-danger mt-1">
                                  Product Name is required
                                </div>
                              )}
                            </FormGroup>
                            <FormGroup className="mt-3">
                              <Label className="fw-semibold">
                                {" "}
                                Product Description
                              </Label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder=" Product Description"
                                value={prodDesc}
                                onChange={(e) => setProdDesc(e.target.value)}
                              />
                              {prodDescError && (
                                <div className="text-danger mt-1">
                                  Product Description is required
                                </div>
                              )}
                            </FormGroup>

                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={saveTranslation}
                            >
                              Save Translation
                            </button>
                          </>
                        )}
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                            }}
                          >
                            {" "}
                            Close{" "}
                          </button>

                          <button
                            type="submit"
                            className="btn btn-success"
                            disabled={validation.isSubmitting}
                          >
                            {validation.isSubmitting ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Submitting...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Products;
